$ = require 'jquery'
Alerts = require 'app/scripts/views/lib/alerts'
Auth = require 'app/scripts/db/auth'
CustomStickerSelectionView = require 'app/scripts/views/stickers/custom-sticker-selection-view'
DragSort = require 'app/scripts/views/lib/drag-sort'
ModelLoader = require 'app/scripts/db/model-loader'
Promise = require 'bluebird'
{ Sticker } = require 'app/scripts/models/Sticker'
Stickers = require 'app/scripts/data/stickers'
StickerSelectionView = require 'app/scripts/views/stickers/sticker-selection-view'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'
{ dontUpsell } = require '@trello/config'
productPromoDisableOverlay = require 'app/scripts/views/templates/product_promo_disable_overlay'
stickerSelect = require 'app/scripts/views/templates/sticker_select'
BoardAddToTeam = require 'app/scripts/views/board-menu/board-add-to-team-view'
Controller = require 'app/scripts/controller'

module.exports = class StickerPickerView extends View
  viewTitleKey: 'stickers'
  viewIcon: 'sticker'
  className: 'board-menu-content-frame'

  initialize: ->
    @me = Auth.me()

    ModelLoader.loadMemberCustomStickers(@me.id).done()

    @listenTo @me.customStickerList, 'change add remove reset', @renderCustomStickers
    @listenTo @model, 'cancel-add-to-team', =>
      @addToTeam = false
      @render()

  events:
    'change .js-upload-image': 'setUploadImage'
    'click a[href="/business-class"]': ->
      track("Board Menu", "Open Business Class Promo - via Sticker Picker")
    'click .ads-layout-experiment .learn-more': ->
      track("Board Menu", "Learn more about Business Class from ads - via Sticker Picker")
    'click .ads-layout-experiment .js-upgrade-team': ->
      track("Board Menu", "Upgrade to Business Class from ads - via Sticker Picker")
    'click .js-add-team': (e) ->
      Util.stop(e)
      if !@model.owned()
        # We aren't an admin on this board so redirect to business-class page
        window.location = '/business-class'
      else
        @addToTeam = true
        @render()

  render: ->
    @$el.empty()
    org = @model.getOrganization() ? null

    if @addToTeam
      ModelLoader.loadMyOrganizations()

      @$el.parent().addClass('no-padding')
      @appendSubview @subview(BoardAddToTeam, @model, {
        menuType: "Stickers"
      })
    else
      data = @model.toJSON()
      data.upgradeUrl = Controller.getUpgradeUrl(@model)
      data.hasOrganization = @model.hasOrganization()
      data.additionalStickersEnabled = @me.isFeatureEnabled('additionalStickers') || org?.isFeatureEnabled('additionalStickers')
      data.upsellEnabled = !dontUpsell

      @$el.html(stickerSelect(data))

      @renderStandardStickers()
      @renderPremiumStickers()
      @renderCustomStickers()

      @defer ->
        DragSort.refreshDraggableStickers()

    @

  _getStickers: (pack) ->
    { premium } = Stickers[pack]
    Stickers[pack].stickers.map (data) ->
      new Sticker(_.extend({ premium }, data), { @modelCache })

  _loadStickers: ($stickerList) ->
    loadingClass = 'sticker-list-loading'
    $stickerList.addClass(loadingClass)

    imgs = $stickerList.find('.sticker-select-image').get()
    imgLoads = imgs.map (img) ->
      $img = $(img)
      new Promise (resolve) ->
        $img.load resolve
        $img.error resolve

    Promise.all(imgLoads)
    .then -> $stickerList.removeClass(loadingClass)
    .done()

  renderStandardStickers: ->
    $standardStickers = @$('.js-standard-sticker-list')

    stickerViews = @_getStickers('standard').map (sticker) =>
      @subview(StickerSelectionView, sticker)

    @appendSubviews stickerViews, $standardStickers

    @_loadStickers $standardStickers

    @

  renderPremiumStickers: ->
    org = @model.getOrganization() ? null
    $parent = @$('.js-premium-stickers')
    enabled = @me.isFeatureEnabled('additionalStickers') || org?.isFeatureEnabled('additionalStickers')

    for pack, { premium } of Stickers when premium
      $stickerPack = $(templates.fill(
        'sticker_pack_selection_list',
        { displayName: l(['sticker packs', pack]) }
      ))

      $stickerPackList = $stickerPack.filter('.js-sticker-list')

      stickerViews = @_getStickers(pack).map (sticker) =>
        @subview(StickerSelectionView, sticker, { org })

      @appendSubviews stickerViews, $stickerPackList

      @_loadStickers $stickerPackList

      $parent.append $stickerPack

      if !enabled
        $stickerPackList.append(
          productPromoDisableOverlay()
        )

    @

  renderCustomStickers: ->
    org = @model.getOrganization() ? null
    $customStickerList = @$('.js-custom-sticker-list')
    $customStickerList.children().detach()

    hasCustomStickers = @me.isFeatureEnabled('customStickers') || org?.isFeatureEnabled('customStickers')

    if hasCustomStickers
      stickerSubviews = @me.customStickerList.map (sticker) =>
        @subview(CustomStickerSelectionView, sticker, { org })
      @appendSubviews stickerSubviews, $customStickerList
    else
      $customStickerList.append(
        productPromoDisableOverlay()
      )
    $customStickerList.append(
      templates.fill('sticker_select_item_upload', { id: @me.id })
    )

    @defer ->
      DragSort.refreshDraggableStickers()

    @

  setUploadImage: (e) ->
    Util.stop(e)
    $file = @$('.js-upload-image')

    if !$file.prop('files')? && $file.val()
      # Yuck, it's IE.  Let's submit the form.
      Util.uploadFile Auth.myToken(), $file, ->
      return

    files = $file[0].files
    if files.length > 0
      @uploadStickers(files)
    return

  uploadStickers: (files) ->
    _.each files, (file) =>
      reader = new FileReader()
      data = { file }

      if !Util.validFileSize(file)
        Alerts.flash('file too large', 'error')
        return

      fd = new FormData()
      fd.append('token', Auth.myToken())
      fd.append('file', file)

      reader.onload = (file) =>
        url = file.target.result
        @me.customStickerList.create { url },
          data: fd
          processData: false
          contentType: false
          error: (model) =>
            model.set('error', 'Failed')
            @setTimeout ->
              model.destroy()
            , 5000

      reader.readAsDataURL(file)
    return
